(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
    const disclosures = [...document.querySelectorAll('.header__search-disclosure')];

    document.querySelectorAll('[data-bb-search-close]').forEach((control) => {
      control.addEventListener('click', () => disclosures.forEach((disclosure) => disclosure.removeAttribute('open')));
    });

    disclosures.forEach((disclosure) => {
      disclosure.addEventListener('toggle', () => {
        if (!disclosure.open) return;

        disclosures.forEach((otherDisclosure) => {
          if (otherDisclosure !== disclosure) otherDisclosure.removeAttribute('open');
        });
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('.header__search-disclosure, .bb-header-search')) return;
      disclosures.forEach((disclosure) => disclosure.removeAttribute('open'));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') disclosures.forEach((disclosure) => disclosure.removeAttribute('open'));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
